import React from "react";
import CountUp, { useCountUp } from 'react-countup';
import DefaultLink from '../../../components/DefaultLink'
import { useModal } from "../../../contexts/ModalContext";
export default function PhysicalTool({ countData }) {
  useCountUp({
    ref: "counter",
    start: 0,
    end: 1234567,
    delay: 1000,
    duration: 3000,
  });

  const {openQueryModal} = useModal();
  return (
    <>
      <section className="physical-tool-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="physical-tool-box">
                <div className="row align-items-center">
                  <div className="col-lg-4 col-md-9 text-center text-md-start">
                    <span>{countData?.title}</span>
                    <p>{countData?.para}</p>
                    <DefaultLink text={countData?.btn} onClick={openQueryModal} />
                  </div>
                  
                  <div className="col-lg-8">
                    <div className="row">
                      {countData?.stats?.map((data, index) => (
                    <div key={index} className="col-lg-4 col-md-4">
                      <div className="physical-count">
                        <span><CountUp end={data?.number} enableScrollSpy />{data?.suffix}</span>
                        <p>{data?.desc}</p>
                      </div>
                    </div>
                  ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}